import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CompanyService } from 'src/app/services/company/company.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { AddImportantNoticeComponent } from '../../add-important-notice/add-important-notice.component';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { AddStaffSurveyComponent } from '../add-staff-survey/add-staff-survey.component';
import { StaffSurveyService } from 'src/app/services/staff-survey/staff-survey.service';
import { AssignStaffSurveyComponent } from '../assign-staff-survey/assign-staff-survey.component';
import { PaginationInstance } from 'ngx-pagination';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { Filter } from '../../filter/filter.model';

@Component({
  selector: 'app-staff-survey-dashboard',
  templateUrl: './staff-survey-dashboard.component.html',
  styleUrls: ['./staff-survey-dashboard.component.scss']
})
export class StaffSurveyDashboardComponent {
  public pageSizeOptions = GlobalService.pageSizeOptions;

  // public displayedColumns: string[] = ['title' ,'department', 'description', 'start_date','end_date','action'];
  public displayedColumns: string[] = [ 'title', 'start_date', 'end_date', 'survey_count', 'status', 'action'];
  public dataSource = new MatTableDataSource();
  public count!: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  public isFilterShow: boolean = false;
  pageIndex = 0;
  pageSize = 15;
  public isSpinnerLoading:boolean=false
  private animationConfig:{}={ enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"}
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public filterObj: Filter = {
    operand: "or",
    arr: []
  }
  public filterArr: any[] = [
    { key_name: "Title", key_val: "tit", type: 'text' },
    { key_name: "Department", key_val: "d_i", type: 'select' },
    { key_name: "Start Date", key_val: "st_dt", type: 'date' },
    { key_name: "End Date", key_val: "ed_dt", type: 'date' },
  ]
  public searchInput: string = '';
  private previousInputValue: string = '';

  constructor(private _liveAnnouncer: LiveAnnouncer, public dialog: MatDialog, private router: Router,private companyService:CompanyService,
    private spinner: NgxSpinnerService,private staffSurveyService:StaffSurveyService ,private appService:AppService, private commonService: CommonService,) { }
  
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.commonService.setTitle("Staff Survey")
    //  this.list()
    // instead of calling list i am calling onPageChange() by passing 1 as else two times api were being called
    //as pageChnage gets triggered when page reloads for the first time.
  this.onPageChange(1)
  }
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
  onFilterView() {
    this.isFilterShow = !this.isFilterShow;
    if (!this.isFilterShow && this.filterObj.arr.length > 0) {
      this.filterObj.arr = [];
      this.list()
    }
    // if (this.isFilterShow == true) { this.filterArr = [{ filter_value: '', contains: '', containsArr: [''] }] }
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.list()
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    this.list()
  }
  onAddNewSurvey(){
    const dialogRef = this.dialog.open(AddStaffSurveyComponent, {
      width: '96%',
      height: '94%',
      maxHeight:"800px",
      maxWidth: '100%',
      panelClass: 'addCourseModal',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(result["data_added"]==true){
          this.list()
        }
      }
    });
  }
  onEditItem(id: number) {
    const dialogRef = this.dialog.open(AddStaffSurveyComponent, {
      width: '96%',
      height: '94%',
      maxHeight:"800px",
      maxWidth: '100%',
      panelClass: 'addCourseModal',
      data:{is_edit:true,id:id},
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(result["data_added"]==true){
          this.list()
        }
      }
    });
  }
  onAssignSurvey(id:string){
    const dialogRef = this.dialog.open(AssignStaffSurveyComponent, Object.assign({
      data:id,   width: '50%', minWidth: '310px', height: '98%', maxHeight: '500px',maxWidth:'700px',autoFocus:false,
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire"}, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
    });
    
  }
  onViewStats(id:number){
    this.router.navigate(['staff-survey/statistics'],{queryParams:{id:id}})
  }
  list = (): void => {
    this.isSpinnerLoading = true;
    let obj = {
      sh: this.searchInput.trim(),
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      f_a: this.filterObj.arr,
      op_nd: this.filterObj.operand
    };
    this.staffSurveyService.list(obj).subscribe({
        next :(success: any) => {
      this.isSpinnerLoading = false;
      if (success.status == 200) {
        this.previousInputValue = this.searchInput;
        this.dataSource = new MatTableDataSource(success.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.count = success.count;
      }},
        error: (error: any) => {
          this.isSpinnerLoading = false;
          this.commonService.handleError(error);
        },

    });

  }
  onDeleteItem( id: any) {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_survey", id:id }}, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"]==true)) {
       this.list()
      }
    });
  }
  doFilter = (event: any) => {
    let newVal = event.target?.value
    this.dataSource.filter = newVal.trim().toLocaleLowerCase()
  }
  onPageEvent = (event: any) => {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    let startPage = (event.pageIndex) * (event.pageSize) + 1;
  }
  callApi(obj) {
    this.filterObj = obj
    this.list()
  }
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.config.currentPage=0
      this.list()
    }
  }
  onGo(){
    if(this.searchInput.trim()!=''){
      this.config.currentPage=0
      this.list()
    }
  }
}
